<template>
  <div>
    Logging out of Lima
  </div>
</template>

<script>
import { apiConfig } from "@/lib/config"
import { UsersAPI } from "@/lib/api"
import User from "@/lib/user"

export default {
  created: function() {
    this.logout()
  },
  methods: {
    logout: function() {
      UsersAPI.logout().then(
        response => {
          User.removeToken()
          this.$store.dispatch("clearAll")
          apiConfig.headers.Authorization = ""
          this.$toasted.clear()
          this.$toasted.success("logged out", {
            position: "top-center",
            duration: 2200,
            fullWidth: false,
            theme: "bubble"
          })
          this.$router.replace({ name: "login" })
        },
        error => {
          User.removeToken()
          apiConfig.headers.Authorization = ""
          this.$store.dispatch("clearAll")
          this.$toasted.clear()
          this.$toasted.success("logged out", {
            position: "top-center",
            duration: 2200,
            fullWidth: false,
            theme: "bubble"
          })
          this.$router.replace({ name: "login" })
        }
      )
    }
  }
}
</script>
